import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

// components
import LoginFormController from "./Login.form.controller";

// mui
import { Typography } from "@mui/material";

// contexts
import { AuthenticationContext } from "../../../contexts/authentication";

import "./Login.css";

export default function Login() {
  const history = useHistory();
  const authentication = useContext(AuthenticationContext);

  const handleSuccess = (token, refresh) => {
    authentication.setAuthenticationStatus(token, refresh);
    history.push("/");
  };

  return (
    <div id="Login">
      <Typography variant="h2">Login</Typography>
      <LoginFormController onSuccess={handleSuccess} />
    </div>
  );
}
